import { gsap } from "gsap";
import { Revealer, ReavealerState } from "./Revealer";
import { RevealerFull } from "./RevealerFull";
import { SanSymbolData } from '../../engine/Symbol/SanSymbolData';
import { ArrayHelper } from "../../../core/utils/ArrayHelper";
import { Helper } from "../../../core/utils/Helper";
import { CommonAnimations } from "../../proto/CommonAnimations";
import { SanEngineManager } from "../../engine/SanEngineManager";

export class RevealerManager extends PIXI.Container {
    
    private amount:number = 5;

    protected static revealer_Top:Revealer[];
    protected static revealer_Bot:Revealer[];

    protected topCont:PIXI.Container;
    protected botCont:PIXI.Container;

    protected topCont_Opened:PIXI.Container;
    protected botCont_Opened:PIXI.Container;

    protected topMask:PIXI.Graphics;
    protected botMask:PIXI.Graphics;

    protected static fullReelRevealer:RevealerFull[];

    protected text:PIXI.Text;

    public get topAndBotCont():PIXI.Container[]{
        return [this.topCont,this. botCont];
    }

    private get halfSymHeight(): number {
        return SanSymbolData.fetchSymHeightSize(2);
    }

    private get halfhalfSymHeight(): number {
        return SanSymbolData.fetchSymHeightSize(1);
    }

    public static getTopBar(pos:number):Revealer{
        return this.revealer_Top[pos];
    }

    public static getBotBar(pos:number):Revealer{
        return this.revealer_Bot[pos];
    }

    public static checkBothState(pos:number,type:string):boolean{
        return this.revealer_Bot[pos].state.equal(type) && this.revealer_Top[pos].state.equal(type);
    }

    public static expanded():boolean{
        return !!this.revealer_Bot.find(v => v.isExpanded) || !!this.revealer_Top.find(v => v.isExpanded);
    }

    public static getAllBars():Revealer[]{
        return this.revealer_Bot.concat(this.revealer_Top);
    }

    public static FullRevealer(pos:number):RevealerFull{
        return this.fullReelRevealer[pos];
    }

    public get topContPos():PIXI.Point{
        return new PIXI.Point(0,-SanSymbolData.fetchSymHeightSize(2) + -SanSymbolData.fetchSymHeightSize(1));
    }
    public get botContPos():PIXI.Point{
        return new PIXI.Point(0,SanSymbolData.fetchSymHeightSize(4)*4 -SanSymbolData.fetchSymHeightSize(1));
    }

    constructor(){
        super();
        this.initiate();
    }

    initiate():void{
        this.topCont = this.addChild(new PIXI.Container());
        this.topCont.name = "topCont";
        this.botCont = this.addChild(new PIXI.Container());
        this.botCont.name = "bottCont";

        this.topCont_Opened = this.addChild(new PIXI.Container());
        this.topCont_Opened.name = "topContOpen";
        this.botCont_Opened = this.addChild(new PIXI.Container());
        this.botCont_Opened.name = "bottContOpen";

        this.topMask = this.createGraphic();
        this.botMask = this.createGraphic();

        this.topCont.mask = this.topMask;
        this.botCont.mask = this.botMask;
        // this.mask = this.maskElement;

        // this.useMasking(false);

        this.topCont.addChild(...this.createRevealers(true));
        this.botCont.addChild(...this.createRevealers(false));

        RevealerManager.revealer_Top = this.topCont.children.map((v) => {return (v as Revealer)});
        RevealerManager.revealer_Bot = this.botCont.children.map((v) => {return (v as Revealer)});

        RevealerManager.fullReelRevealer = ArrayHelper.initArrayWithValues(this.amount, () => { return this.addChild(new RevealerFull()) });

        this.onResize();
    }

    normalIndiviMasking(){
        RevealerManager.revealer_Top.forEach(v => v.revSpinner.useIndividualMasking());
        RevealerManager.revealer_Bot.forEach(v => v.revSpinner.useIndividualMasking());
    }

    applyIndiviMask(value:boolean){

        RevealerManager.revealer_Top.forEach(v => {
            if(v.isActive)
                this.topCont_Opened.addChild(v);
            else
                this.topCont.addChild(v);}
        )

        RevealerManager.revealer_Bot.forEach(v => {
            if(v.isActive)
                this.botCont_Opened.addChild(v);
            else
                this.botCont.addChild(v);}
        )

        if(this.botCont.children.length){
            this.topMask.visible = value;
            this.botMask.visible = value;
            this.topCont.mask = value ? this.topMask : null!;
            this.botCont.mask =  value ? this.botMask : null!;
        }

        if(value){
            RevealerManager.revealer_Top.forEach(v => v.revSpinner.useMasking(v.isActive));
            RevealerManager.revealer_Bot.forEach(v => v.revSpinner.useMasking(v.isActive));
        }

        this.normalIndiviMasking();
    }

    public static setResData(top?:string[], bot?:string[], mystSym?:string, isFS?:boolean):void{
        if(top) RevealerManager.revealer_Top.forEach((rev:Revealer, indx:number) => rev.setResult(top[indx],mystSym!,isFS));
        if(bot) RevealerManager.revealer_Bot.forEach((rev:Revealer, indx:number) => rev.setResult(bot[indx],mystSym!,isFS));

        for(let k:number = 0; k < RevealerManager.revealer_Top.length; k++){
            if(this.checkBothState(k,ReavealerState.EXPANDING)){
                if(top) RevealerManager.revealer_Top[k].setResult(top[k],"W",isFS);
                if(bot) RevealerManager.revealer_Bot[k].setResult(bot[k],"W",isFS);
            }
        }

    }

    public static setSpecialData(sym:string,val:number):void{
        this.getAllBars().forEach(rev => rev.setSpecial(sym,val))
    }
    
    public static getRevealer(reel:number, pos:number):Revealer{
        return (pos > 0 ?  RevealerManager.revealer_Top : RevealerManager.revealer_Bot)[reel];
    }

    private createRevealers(top:boolean):Revealer[] {
        const temp:Revealer[] = [];
        for(let i:number = 0; i < this.amount;i++) temp.push(this.addChild(new Revealer(i,top)));
        return temp;
    }

    private createGraphic(): PIXI.Graphics {
        const graphicBg: PIXI.Graphics = new PIXI.Graphics();

        const c: number = 0x000000;
        graphicBg.beginFill(c, 1);

        graphicBg.drawRect(0, 0,
            SanSymbolData.DEFAULT_DIM.WIDTH *5 +SanSymbolData.DEFAULT_DIM.PADDING_X *4, this.halfSymHeight + 2);

        graphicBg.endFill();
        this.addChild(graphicBg);
        return graphicBg;
    }

    public reApplyToOriginCont():void{
        RevealerManager.revealer_Top.forEach(v => {
            this.topCont.addChild(v);
        })
        RevealerManager.revealer_Bot.forEach(v => {
            this.botCont.addChild(v);
        })
    }

    public onResize():void{

        this.topCont.position = this.topCont_Opened.position  = this.topContPos;
        this.botCont.position = this.botCont_Opened.position  = this.botContPos;

        this.topMask.position = this.topCont.position;
        this.topMask.position.y -= this.halfhalfSymHeight;
        this.botMask.position = this.botCont.position;
        this.botMask.position.y -= this.halfhalfSymHeight;

        for (let r: number = 0; r < RevealerManager.revealer_Top.length; r++) {
            RevealerManager.revealer_Top[r].onResize();
            RevealerManager.revealer_Bot[r].onResize();
        }

        RevealerManager.fullReelRevealer.forEach((rev: RevealerFull, indx: number) => {
            rev.position = Helper.copyLocalPosition(rev, SanEngineManager.getReel(indx));
            rev.position.y += SanSymbolData.DEFAULT_DIM.HEIGHT * 2.75;
        });
    }
}